export const ACTIVATION_CASE_TYPE_ID = 'Vb-PcClm-Work-Activate';
export const CASE_DETAILS_DATA_PAGE_ID = 'D_CLMCaseDetailsFEP';

export enum AnalyticsReporter {
    FRONTEND_APPLICATION = 'frontend',
    PEGA = 'pega'
}

export enum CasePrefix {
    ACTIVATION_JOURNEY = 'ACJ',
    ORCHESTRATION = 'ORC',
    ORIENTATION = 'OT',
    ONBOARD_NEW_CUSTOMER = 'ONC'
}

export enum DistributionChannelType {
    RETAIL = 'Retail',
    MOBIEL = 'MobileApp'
}
